





define(['http', './utils', 'security', 'endpoints'], function(http, utils, security, endpoints) {
    'use strict';

    var queryParamsNames = ['geometries'];

    return {
        additionalData: function(options, callback) {
            var pathParams = {};
            var queryParams = {};
            var httpParams;

            // if an API key is specified, include it
            // an API key can be omitted if an API proxy is being used
            queryParams.key = utils.or(options.key, security.getKey('services/search'));

            // look for optional passed params and set them if they are not undefined
            utils.extractQueryParams(options, queryParams, queryParamsNames);

            httpParams = {
                url: 'https://' + endpoints.adp,
                pathParameters: pathParams,
                queryParameters: queryParams,
                callback: callback,
                callbackParam: 'callback',
                fail: options.fail
            };

            http.get(httpParams);
        }
    };
});



// WEBPACK FOOTER //
// ./rest/additionalData.js